/* This file is autogenerated, see readme.md for instructions */
import AndroidSvgIcon from '@bloomreach/banana-theme/icons/android.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const AndroidIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <AndroidSvgIcon />
    </Icon>
  );
});

AndroidIcon.displayName = 'AndroidIcon';

export default AndroidIcon;
